import React, { useEffect } from "react";
import { Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { PAGE_SIZE } from "../../../constants";
import { fetchSpinReports } from "../../../actions/spinTheWheelReports";
import SpinTheWheelReportsTable from "../../Tables/SpinTheWheelReports";

const SpinTheWheelReportsPage = () => {
	const dispatch = useDispatch();
	const { reports, loading } = useSelector((state) => state.fetchSpinReports);

	useEffect(() => {
		dispatch(fetchSpinReports({ start: 0, count: PAGE_SIZE }));
	}, []);

	return (
		<Spin spinning={loading} tip="Loading ...">
			<div className="spin-the-wheel-rates-container">
				<div className="page-header">
					<div className="page-header-breadbrumb">
						<ul>
							<li>Number of Spins</li>
						</ul>
					</div>
				</div>
				<div className="page-content">
					{reports && (
						<SpinTheWheelReportsTable
							rowKey="date"
							dataSource={reports.data}
							pagination={false}
							scrollHeight="calc(100vh - 275px)"
						/>
					)}
				</div>
			</div>
		</Spin>
	);
};

export default SpinTheWheelReportsPage;
